export const GALLEY_LAYOUT = 'gallery';
export const ROUTE_PATH = '/showcase/:albumId/embed2';
